import { RouteRecordRaw } from 'vue-router';

import BaseLayout from '@/layouts/base-layout.vue';
import PricingPageAgreement from '@/modules/onboarding/pages/Personal/OnboardingPersonalPricing.vue';
import { getStageIndexMeta } from '@/modules/onboarding/utils';

const OnboardingAddressProof = () => import(
  '@/modules/onboarding/pages/Personal/OnboardingAddressProof.vue'
);

const OnboardingIdentityProof = () => import(
  '@/modules/onboarding/pages/Personal/OnboardingIdentityProof.vue'
);

const OnboardingPersonalLiveScan = () => import(
  '@/modules/onboarding/pages/Personal/OnboardingPersonalLiveScan.vue'
);

const OnboardingPersonalVerification = () => import('@/modules/onboarding/pages/Personal/VerificationPage.vue');

const PersonalData = {
  InfoPage: () => import(
    '@/modules/onboarding/pages/Personal/PersonalData/InfoPage.vue'
  ),
  AddressPage: () => import('@/modules/onboarding/pages/Personal/PersonalData/AddressPage.vue'),
  TurnoverPage: () => import('@/modules/onboarding/pages/Personal/PersonalData/TurnoverPage.vue'),
  FundsSourcePage: () => import('@/modules/onboarding/pages/Personal/PersonalData/FundsSourcePage.vue'),
  VerifyPage: () => import('@/modules/onboarding/pages/Personal/PersonalData/VerifyPage.vue'),
};

const PERSONAL_DETAILS_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'info',
    name: 'onboarding-personal-info',
    component: PersonalData.InfoPage,
    meta: getStageIndexMeta(0),
  },
  {
    path: 'address',
    name: 'onboarding-personal-address',
    component: PersonalData.AddressPage,
    meta: getStageIndexMeta(0),
  },
  {
    path: 'turnover',
    name: 'onboarding-personal-turnover',
    component: PersonalData.TurnoverPage,
    meta: getStageIndexMeta(0),
  },
  {
    path: 'funds-source',
    name: 'onboarding-personal-funds',
    component: PersonalData.FundsSourcePage,
    meta: getStageIndexMeta(0),
  },
  {
    path: 'verify',
    name: 'onboarding-personal-verify',
    component: PersonalData.VerifyPage,
    meta: getStageIndexMeta(0),
  },
];

const STAGES = [
  'pages.onboarding.personal.stages.personal_data',
  'pages.onboarding.personal.stages.proof_of_identity',
  'pages.onboarding.personal.stages.proof_of_address',
  'pages.onboarding.personal.stages.liveness_check',
  'pages.onboarding.personal.stages.plan',
];

const PERSONAL_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'data',
    name: 'onboarding-personal-data',
    children: PERSONAL_DETAILS_CHILDREN,
    redirect: PERSONAL_DETAILS_CHILDREN[0],
  },
  {
    path: 'proof-of-identity',
    name: 'onboarding-personal-proof-of-identity',
    component: OnboardingIdentityProof,
    meta: getStageIndexMeta(1),
  },
  {
    path: 'proof-of-address',
    name: 'onboarding-personal-proof-of-address',
    component: OnboardingAddressProof,
    meta: getStageIndexMeta(2),
  },
  {
    path: 'liveness-check',
    name: 'onboarding-personal-liveness-check',
    component: OnboardingPersonalLiveScan,
    meta: getStageIndexMeta(3),
  },
  {
    path: 'pricing',
    name: 'onboarding-personal-pricing',
    component: PricingPageAgreement,
    meta: getStageIndexMeta(4),
  },
  {
    path: 'verify',
    name: 'onboarding-personal-verification',
    component: OnboardingPersonalVerification,
    meta: {
      layout: {
        componentName: 'BaseLayoutWithLogout',
      },
    },
  },
];

export const PERSONAL = {
  path: 'personal',
  name: 'onboarding-personal',
  children: PERSONAL_CHILDREN,
  component: BaseLayout,
  props: {
    fetchProfile: false,
    baseLayoutConfig: {
      componentName: 'OnboardingPersonalLayout',
      props: {
        stages: STAGES,
      },
    },
  },
};
